import type { FunctionComponent, ReactNode } from "react";

import styled from "styled-components";

import { PrimaryBoxTitle } from "pro-features/styled components/StyledBoxTitle/src/StyledBoxTitle";
import { FlexColumn, FlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

import type { SelectorHandlers } from "app/components/filters-bar/useSelectorTrigger";

import { StyledSubtitle, SubTitleWrapper } from "./StyledComponents";

interface IWidgetTitleProps extends SelectorHandlers {
    title: string;
    className?: string;
    tooltip?: string;
    filters?: any[];
    addToDashboard?: () => ReactNode;
    children?: ReactNode;
    displayBetaLabel?: boolean;
}

const PrimaryTitleStyle = styled.div`
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
    max-width: 90%;
`;

const WidgetTitleWrapper = styled(FlexRow)`
    justify-content: space-between;
    width: 100%;
`;

export const WidgetTitle: FunctionComponent<IWidgetTitleProps> = ({
    children,
    className,
    title,
    tooltip,
    filters,
    addToDashboard,
    displayBetaLabel = false,
    onDateClick,
    onCountryClick,
    onDateHover,
    onCountryHover,
    onWebSourceHover,
}) => {
    const handlerByFilter: Record<string, VoidFunction | undefined> = {
        date: onDateClick,
        country: onCountryClick,
    };
    const hoverHandlerByFilter: Record<string, VoidFunction | undefined> = {
        date: onDateHover,
        country: onCountryHover,
        webSource: onWebSourceHover,
    };
    const clickableFilters = filters?.map((filter) => {
        const onClick = handlerByFilter[filter?.filter];
        const onMouseEnter = hoverHandlerByFilter[filter?.filter];
        if (onClick && !filter.onClick) {
            return { ...filter, onClick, ...(onMouseEnter ? { onMouseEnter } : {}) };
        }
        if (onMouseEnter && !filter.onMouseEnter) {
            return { ...filter, onMouseEnter };
        }
        return filter;
    });

    return (
        <WidgetTitleWrapper className={className}>
            <FlexColumn style={{ width: "100%" }}>
                <PrimaryBoxTitle
                    tooltip={tooltip}
                    badge={displayBetaLabel ? "beta" : null}
                >
                    <PrimaryTitleStyle>{title}</PrimaryTitleStyle>
                </PrimaryBoxTitle>
                {clickableFilters ? (
                    <SubTitleWrapper>
                        <StyledSubtitle filters={clickableFilters} />
                    </SubTitleWrapper>
                ) : null}
            </FlexColumn>
            {addToDashboard ? addToDashboard() : null}
            {children}
        </WidgetTitleWrapper>
    );
};
